import script from "./PlanningOnboarding.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanningOnboarding.vue?vue&type=script&setup=true&lang=js"

import "./PlanningOnboarding.vue?vue&type=style&index=0&id=a63df254&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a63df254"]])

export default __exports__